export class Pinpad {
    constructor(optionalOptions = {}) {
        this._pinpadInputs = document.querySelector('.user-profile-pinpad--inputs');

        if (!this._pinpadInputs) {
            this.destructor();
            return true;
        }

        let inputs, input, inputValue
        let inputTwo

        this._pinpad = document.querySelectorAll('[data-action=\'pinpad\']');
        this._pinpad.forEach((button) => {
            button.addEventListener("click", (event) => {
                inputs = this._pinpadInputs.querySelectorAll('input')
                if (!inputs) {
                    return false;
                }

                input = false
                inputTwo = false

                inputs.forEach((inp) => {
                    inputValue = inp.value.trim()
                    if (inputValue === "" && !input) {
                        input = inp;
                    }

                    if (inputValue !== "") {
                        inputTwo = inp;
                    }
                })

                if (button.dataset.value !== 'backspace' && input) {
                    input.value = button.dataset.value;
                } else if(button.dataset.value === 'backspace' && inputTwo) {
                    inputTwo.value = '';
                }
            })
        })
    }

    destructor() {
        this._pinpadInputs = null;
    }
}

export default new Pinpad();